<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
</div>
<div class="modal-body">
  <p [innerHTML]="text"></p>
</div>
